<template><div><h1>为什么不能引入全部组件</h1>
<p>移动端引入全部组件会导致体积过大，加载速度慢，浪费用户等待时间并且浪费(cdn)带宽。</p>
<p>另一方面随着组件库迭代，组件数量增加，这个体积会逐渐变得不可接受。</p>
<p>因此 <code>VUX</code> 没有像其他组件库一样直接提供全部引入的使用方式，按需使用是最佳实践。</p>
<p>如果你只是不想每次在单个 <code>.vue</code> 文件里重复地 <code>import</code>，那么你可以直接在 <code>main.js</code> 里进行全局注册。</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Group, Cell } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

Vue.component(<span class="hljs-string">'group'</span>, Group)
Vue.component(<span class="hljs-string">'cell'</span>, Cell)
</code></pre>
<div class="tip">
<p><code>VUX@3.0</code> 将会实现无声明使用组件。</p>
</div>
</div></template><script>
export default {
  head: {"title":"为什么不能引入全部组件？ | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// why-cannot-i-import-all-components-25.vue?fbaaeb70